// Rodolfo Rivas
// Rodolfo Rivas
// 2017
//*************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
//*************************************************************//


import {Component, HostListener, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UtilConfig} from "../../../../autenticacion/servicios/UtilConfig";
import {LogSunat} from "./recursos/modelo/LogSunat";
import * as moment from 'moment';
import {BsDatepickerConfig, BsLocaleService} from 'ngx-bootstrap/datepicker';

import {ScrollEvent} from 'ngx-scroll-event';
import {FormControl} from "@angular/forms";
import {WebServices} from "../../../recursos/modelo/consumerModel/web-services.enum";
import {ConsumerService} from "../../../recursos/servicio/consumer.service";
import {Ng2DeviceService} from "ng2-device-detector";
import {LayoutService} from "../../../recursos/servicio/layout.service";

declare var swal: any;

declare const $: any;

@Component({
    moduleId: module.id,
    selector: 'app-log',
    templateUrl: './view/list-logSunat.component.html',
    styleUrls: ['./css/list-logSunat.component.css'],
    providers: [ConsumerService]
})
export class LogSunatComponent implements OnInit, OnChanges {

    // ITEM DEL CRUD
    origenCRUD = "documento";

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─
    // variables de pantalla
    filtroList = {
        search: "",
        verDetalle: false,
        estadoRegistro: "TODAS",
        tipoFecha: "SUBIDA",
        moneda: "PEN",
        rangoMontoMin: "",
        rangoMontoMax: "",
        numeroSerie: "",
        rangoMinConsecutivo: "",
        rangoMaxConsecutivo: "",
        document: "-1"

    };
    todos = false;
    stringDescarga = [];
    imprimir = false;
    URL_DESCARGA_MASIVA;
    URL_IMPRESION_MASIVA;
    link_descarga = "";
    link_impresion = "";
    descargar = false;
    activoDescarga = false;
    mensaje = "<i class='material-icons'>search</i>REALICE SU BUSQUEDA UTILIZANDO LOS FILTROS";
    loading = false;
    noHayResultados = false;
    es;
    to = "0";
    max = "9999999";
    filtro = false;
    cargandoConsulta = false;
    cargandoList = false;
    selectedMovil: boolean = false;
    documentType: any[] = [];
    monedaType: any[] = [];
    searchField: FormControl;
    serieField: FormControl;
    rangoMinConsecutivoField: FormControl;
    rangoMaxConsecutivoField: FormControl;
    emisor = "";
    empresaAdministradora = false;
    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_LOG_SUNAT_LISTAR: false,
        ROLE_LOG_SUNAT_CONSULTAR: false,
        ROLE_LOG_SUNAT_REGISTRAR: false,
        ROLE_LOG_SUNAT_MODIFICAR: false,
        ROLE_LOG_SUNAT_ELIMINAR: false,
        ROLE_LOG_SUNAT_ACTIVAR: false,
    };
    //variables modelo
    ItemLista: any[];
    ItemSelected: LogSunat;
    rangeDates: Date[];
    logSeleccionado = new LogSunat();
    locale = 'es';
    colorTheme = 'theme-dark-blue';
    bsConfig: Partial<BsDatepickerConfig>;
    inicial = true;
    // scroll list
    scrollItems: LogSunat[] = [];
    readonly bufferSize: number = 50;
    timer: any;
    loadingTexto: boolean = false;
    loadingTextoRefinir: boolean = false;
    totalRegistros = 0;

    private colorTitle = null;

    constructor(private consumer: ConsumerService,
                private route: ActivatedRoute,
                private router: Router,
                private layout: LayoutService,
                private jwtUtil: UtilConfig,
                private _localeService: BsLocaleService,
                private deviceService: Ng2DeviceService) {

        this._localeService.use(this.locale);

        this.documentType = [];
        this.documentType.push({label: 'TODOS', value: "-1"});
        this.documentType.push({label: 'FACTURA', value: "INVOICE"});
        this.documentType.push({label: 'BOLETA', value: "TICKET"});
        this.documentType.push({label: 'NOTA DE CRÉDITO', value: "CREDIT_NOTE"});
        this.documentType.push({label: 'NOTA DE DÉBITO', value: "DEBIT_NOTE"});
        this.documentType.push({label: 'PERCEPCIONES', value: "PERCEPTION"});
        this.documentType.push({label: 'RETENCIONES', value: "RETENTION"});
        this.documentType.push({label: 'GUÍA DE REMISIÓN', value: 'DESPATCH_ADVICE'});
        this.documentType.push({label: 'GUÍA TRANSPORTISTA', value: 'DESPATCH_TRANSPORT'});
        this.documentType.push({label: 'RESUMEN DIARIO', value: "SUMMARY_DOCUMENT"});
        this.documentType.push({label: 'COMUNICACIÓN DE BAJA', value: "RA_VOIDED_DOCUMENT"});
        this.documentType.push({label: 'RESUMEN DE REVERSIONES', value: "RR_VOIDED_DOCUMENT"});

        this.monedaType = [];
        this.monedaType.push({description: 'TODAS', code: "TODAS"});
        this.monedaType.push({description: 'SOLES', code: "PEN"});
        this.monedaType.push({description: 'DÓLARES', code: "USD"});
        this.monedaType.push({description: 'EUROS', code: "EUR"});
        this.monedaType.push({description: 'LIBRAS ESTERLINAS', code: "GBP"});

        this.URL_DESCARGA_MASIVA = this.jwtUtil.URL_WS_BACKEND + "/reporte/emitir?" +
            "reporte.id=7&" +
            "formato=EXCEL&" +
            "reporte.nombre=Exportación de documentos enviados&" +
            "reporte.fileName=exportEnviados&" +
            "reporte.urlJasper=exports/exportEnviados.jasper&";
        this.URL_IMPRESION_MASIVA = this.jwtUtil.URL_WS_BACKEND + "/reporte/emitir?" +
            "reporte.id=7&" +
            "formato=EXCEL&" +
            "reporte.nombre=Exportación de documentos enviados&" +
            "reporte.fileName=exportEnviados&" +
            "reporte.urlJasper=exports/exportEnviados.jasper&";
        this.ItemLista = [];

        this.bsConfig = Object.assign({}, {
            containerClass: this.colorTheme,
            showWeekNumbers: false,
            dateInputFormat: 'DD/MM/YYYY'
        });

        var fechaIni = (new Date().getMonth() + 1) + "/01/" + new Date().getFullYear();
        this.rangeDates = [new Date(), new Date()];
        this.es = jwtUtil.CONFIG_ES_CALENDAR;

        this.emisor = jwtUtil.getCurrentUser().customer.id;
        // SI LA EMPRESA ES ESCON SE HABILITAN LOS SELECT
        if (this.emisor == jwtUtil.ESCON_CUSTOMER)
            this.empresaAdministradora = true;

        // VERIFICA LOS PERMISOS DEL LOG LOGEADO
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);
        if (this.authorities.ROLE_LOG_SUNAT_LISTAR)
            this.route.params.subscribe(params => {
                if (params['busqueda']) {
                    this.filtroList.search = params['busqueda'];
                }

                if (params['numeroSerie']) {
                    this.filtroList.numeroSerie = params['numeroSerie'];
                }

                // RANGO CONSECUTIVO
                if (params['minConsecutivo']) {
                    this.filtroList.rangoMinConsecutivo = params['minConsecutivo'];
                }
                if (params['maxConsecutivo']) {
                    this.filtroList.rangoMaxConsecutivo = params['maxConsecutivo'];
                }

                // RANGO MONEDA
                this.filtroList.moneda = params['moneda'] || "TODAS";
                if (params['minMonto']) {
                    this.filtroList.rangoMontoMin = params['minMonto'];
                }
                if (params['maxMonto']) {
                    this.filtroList.rangoMontoMax = params['maxMonto'];
                }

                // RANGO FECHA
                this.filtroList.tipoFecha = params['tipoFecha'] || "SUBIDA";
                if (params['inicio']) {
                    this.rangeDates[0] = new Date(params['inicio']);
                }
                if (params['fin']) {
                    this.rangeDates[1] = new Date(params['fin']);
                }

                if (params['inicial']) {
                    this.inicial = false;
                }

                this.filtroList.document = params['documentType'] || "-1";
                this.filtroList.estadoRegistro = params['estado'] || "TODAS";
                this.realizarBusqueda();
            });


        if (this.jwtUtil.getColorTitle()) {
            this.colorTitle = this.jwtUtil.getColorTitle();
        }
        this.layout.getColorTitle().subscribe(colorTitle => {
            this.colorTitle = colorTitle;
        });
    }

    @HostListener('window:keyup.escape', ['$event'])
    keyEvent(event: KeyboardEvent) {
        $("ul#slide-out").removeClass("open");
        $("i.cerrarAleta").removeClass("open");
        $.each(this.ItemLista, function (pos, item) {
            item.seleccionado = false;
        });
    }

    public handleScroll(event: ScrollEvent) {
        if (event.isReachingBottom) {
            this.fetchMore(event);
        }
        if (event.isWindowEvent) {
            this.fetchMore(event);
        }

    }

    fetchMore(event) {
        if (this.scrollItems.length != this.ItemLista.length) {
            this.loadingTexto = true;
            this.fetchNextChunk(this.scrollItems.length, this.bufferSize, event).then(chunk => {
                this.scrollItems = this.scrollItems.concat(chunk);
                this.loadingTexto = false;
            }, () => this.loadingTexto = false);
        } else {
            this.loadingTexto = false;
            this.loadingTextoRefinir = true;
        }
    }

    fetchNextChunk(skip: number, limit: number, event?: any): Promise<LogSunat[]> {
        return new Promise((resolve, reject) => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if (skip < this.ItemLista.length) {
                    return resolve(this.ItemLista.slice(skip, skip + limit));
                }
                reject();
            }, 1000 + Math.random() * 1000);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        this.reset();
    }

    reset() {
        this.fetchNextChunk(0, this.bufferSize, {}).then(chunk => {
            this.scrollItems = chunk;
            this.cargandoList = false;
        });
    }

    ngOnInit() {

        if (this.deviceService.isMobile() || this.deviceService.isTablet())
            this.selectedMovil = true;


        this.searchField = new FormControl();
        this.searchField.valueChanges
            .debounceTime(1000)
            .distinctUntilChanged()
            .subscribe(term => {
                if (!this.inicial) {
                    this.listar();
                }
            });

        this.getMonedas();
    }

    getMonedas() {
        this.consumer.post<any>(WebServices.URL_GET_MONEDAS)
            .subscribe(result => {
                let monedas: any = result["currencyCodes"];
                if (monedas != null && monedas.length > 0) {
                    this.monedaType = [];
                    this.monedaType.push({description: 'TODAS', code: "TODAS"});
                    $.each(monedas, (pos, item) => {
                        this.monedaType.push({description: item.description, code: item.code});
                    });
                }
            }, err => {
            });

    }

    limpiarFiltros() {
        this.filtroList.estadoRegistro = "TODAS";
        this.filtroList.moneda = "PEN";
        this.filtroList.rangoMontoMin = "";
        this.filtroList.rangoMontoMax = "";
        this.filtroList.numeroSerie = "";
        this.filtroList.rangoMaxConsecutivo = "";
        this.filtroList.rangoMinConsecutivo = "";
        this.filtroList.document = "-1";
        this.to = "0";
        this.max = "9999999";

    }

    refrescar() {
        this.realizarBusqueda();
    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴


    cambiarEstadoRegistro(estado) {
        this.filtroList.estadoRegistro = estado;
    }

    listar() {
        let filtro: any = {};
        if (this.filtroList.search != "")
            filtro.busqueda = this.filtroList.search;

        // RANGO CONSECUTIVO
        if (this.filtroList.rangoMinConsecutivo != "") {
            filtro.rangoMinConsecutivo = this.filtroList.rangoMinConsecutivo;
        }

        if (this.filtroList.rangoMaxConsecutivo != "") {
            filtro.rangoMaxConsecutivo = this.filtroList.rangoMaxConsecutivo;
        }

        if (this.filtroList.numeroSerie != "") {
            filtro.numeroSerie = this.filtroList.numeroSerie;
        }

        // RANGO MONEDA
        if (this.filtroList.moneda != 'TODAS') {
            filtro.moneda = this.filtroList.moneda;
        }

        if (this.filtroList.rangoMontoMin != "") {
            filtro.rangoMontoMin = this.filtroList.rangoMontoMin;
        }
        if (this.filtroList.rangoMontoMax != "") {
            filtro.rangoMontoMax = this.filtroList.rangoMontoMax;
        }

        // RANGO FECHA
        filtro.tipoFecha = this.filtroList.tipoFecha;
        filtro.inicio = moment(this.rangeDates[0]).format("MM/DD/YYYY");
        filtro.fin = moment(this.rangeDates[1]).format("MM/DD/YYYY");

        filtro.inicial = false;

        filtro.estado = this.filtroList.estadoRegistro;
        filtro.documentType = this.filtroList.document;
        this.router.navigate(['/content', {outlets: {'second': ['logSunat', filtro]}}]);
    }

    toggleFiltros() {
        this.filtro = !this.filtro;
    }


    myOnFinish(event) {
        this.filtroList.rangoMontoMin = event.from;
        this.filtroList.rangoMontoMax = event.to;
    }

    cambiarFecha(tipo) {
        this.filtroList.tipoFecha = tipo;
        this.listar();
    }

    cambiarMoneda(tipo) {
        this.filtroList.moneda = tipo;
    }


    toggleSeleccionarTodos() {
        this.stringDescarga = [];
        if (!this.todos) {
            $.each(this.ItemLista, (pos, item) => {
                item.seleccionado = true;
                this.stringDescarga.push(item.id);
            });
            $.each(this.scrollItems, (pos, item) => {
                item.seleccionado = true;
            });
        } else {
            $.each(this.ItemLista, (pos, item) => {
                item.seleccionado = false;
            });
            $.each(this.scrollItems, (pos, item) => {
                item.seleccionado = false;
            });
        }
    }


    actualizarIds(id) {
        let posId = -1;
        $.each(this.stringDescarga, (pos, item) => {
            if (item.id == id)
                posId = pos;
        });

        if (posId == -1) {
            this.stringDescarga.push(id);
        } else {
            this.stringDescarga.splice(posId, 1);
        }
    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐

    cerrarDetalle() {
        $("ul#slide-out").removeClass("open");
        $("i.cerrarAleta").removeClass("open");
        $.each(this.ItemLista, function (pos, log) {
            log.seleccionado = false;
        });
        this.logSeleccionado = new LogSunat();
    };

    consulta(item) {
        if (!this.activoDescarga) {
            if (item.seleccionado) {
                item.seleccionado = !item.seleccionado;
                $("ul#slide-out").removeClass("open");
                $("i.cerrarAleta").removeClass("open");
                return false;
            }

            $.each(this.ItemLista, function (pos, log) {
                log.seleccionado = false;
            });

            $("ul#slide-out").addClass("open");
            $("i.cerrarAleta").addClass("open");
            item.seleccionado = !item.seleccionado;
            this.logSeleccionado = new LogSunat();
            this.cargandoConsulta = true;
            this.consumer.getById<any>("logSunat", item.id, WebServices.URL_GET_LOG_SUNAT)
                .subscribe(result => {
                    this.logSeleccionado = result["logSunat"];
                    this.logSeleccionado.logCustRequest.fileName = this.logSeleccionado.logCustRequest.fileName.replace(".zip", "");
                    this.logSeleccionado.linkRequestPSE = this.jwtUtil.URL_WS_BACKEND + "/" + WebServices.URL_GET_ARCHIVO_SUNAT + "?log.id=" + this.logSeleccionado.id + "&tipoDescarga=PSE";
                    this.logSeleccionado.linkRequestXML = this.jwtUtil.URL_WS_BACKEND + "/" + WebServices.URL_GET_ARCHIVO_SUNAT + "?log.id=" + this.logSeleccionado.id + "&tipoDescarga=XML";
                    this.logSeleccionado.linkResponseCDR = this.jwtUtil.URL_WS_BACKEND + "/" + WebServices.URL_GET_ARCHIVO_SUNAT + "?log.id=" + this.logSeleccionado.id + "&tipoDescarga=CDR";
                    this.logSeleccionado.linkResponsePDF = this.jwtUtil.URL_WS_BACKEND + "/" + WebServices.URL_GET_ARCHIVO_SUNAT + "?log.id=" + this.logSeleccionado.id + "&tipoDescarga=PDF";
                    this.cargandoConsulta = false;
                }, err => {
                    this.ItemLista = [];
                    this.cargandoConsulta = false;
                    this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo consultar el documento", this.router)
                });
        } else {
            item.seleccionado = !item.seleccionado;
            $("ul#slide-out").removeClass("open");
            $("i.cerrarAleta").removeClass("open");
            this.actualizarIds(item.id);
        }
    }

//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘
    private realizarBusqueda() {
        // LLAMADO AL SERVICIO
        $("ul#slide-out").removeClass("open");
        $("i.cerrarAleta").removeClass("open");
        this.cargandoList = true;
        let params: any = {
            criterio: this.filtroList.search,
            tipoFecha: this.filtroList.tipoFecha,
            fechaDesde: this.rangeDates[0],
            fechaHasta: this.rangeDates[1],
            documentType: (this.filtroList.document == "-1") ? null : this.filtroList.document,
            moneda: (this.filtroList.moneda == "TODAS") ? null : this.filtroList.moneda,
            montoMin: (this.filtroList.rangoMontoMin == "") ? null : this.filtroList.rangoMontoMin,
            montoMax: (this.filtroList.rangoMontoMax == "") ? null : this.filtroList.rangoMontoMax,
            consecutivoMin: (this.filtroList.rangoMinConsecutivo == "") ? null : this.filtroList.rangoMinConsecutivo,
            consecutivoMax: (this.filtroList.rangoMaxConsecutivo == "") ? null : this.filtroList.rangoMaxConsecutivo,
            numeroSerie: (this.filtroList.numeroSerie == "") ? null : this.filtroList.numeroSerie
        };
        if (this.filtroList.estadoRegistro != "TODAS") {
            params.logSunat = {
                status: this.filtroList.estadoRegistro
            }
        }
        this.consumer.post<any>(WebServices.URL_LIST_LOG_SUNAT, params)
            .subscribe(result => {
                this.ItemLista = result["logsSunat"];
                if ((this.ItemLista != null) && (this.ItemLista.length == 0)) {
                    this.mensaje = "<i class='material-icons'>youtube_searched_for</i> UTILICE OTRO FILTRO DE BÚSQUEDA SOBRE <b>" + this.origenCRUD.toUpperCase() + "S </b>, NO SE HAN CONSEGUIDO REGISTROS";
                }
                this.totalRegistros = result["rowsCount"];
                if (this.totalRegistros == 0) {
                    this.cargandoList = false;
                } else {
                    this.reset();
                }

            }, err => {
                this.ItemLista = [];
                this.cargandoList = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo consultar los documentos", this.router)
            });
    }


}




// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/logSunat/list-logSunat.component.ts